import React, { useState } from "react";
import { Tabs, TabsProps } from "antd";

import OwnedCar from "./InfoCar/OwnedCar";
import UsedCar from "./InfoCar/UsedCar";
import InterestedCar from "./InfoCar/InterestedCar";

const VehicleInformation = ({ stData = {} as any, stChange = (data: any) => { }, defaultSubTab = undefined as string | undefined }) => {
  const [activeInfoTab, setActiveInfoTab] = useState(defaultSubTab || "1");

  const itemInfoCarTabs: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <span className="custom-page-css font-light text-lg">
          Xe sở hữu ({stData.xesohuu?.length || 0})
        </span>
      ),
      children: stData.xesohuu ? <OwnedCar stData={stData} stChange={(data) => {
        stChange(data)
      }} /> : null,
    },
    {
      key: "2",
      label: (
        <span className="custom-page-css font-light text-lg">
          Xe sử dụng ({stData.xesudung?.length || 0})
        </span>
      ),
      children: stData.xesudung ? <UsedCar stData={stData} stChange={(data) => {
        stChange(data)
      }} /> : null,
    },
    {
      key: "3",
      label: (
        <span className="custom-page-css font-light text-lg">
          Xe quan tâm ({stData.xequantam?.length || 0})
        </span>
      ),
      children: stData.xequantam ? <InterestedCar stData={stData} stChange={(data) => {
        stChange(data)
      }} /> : null,
    },
  ];

  return (
    <>
      <div
        style={{ width: "100%" }}
      >
        <Tabs
          activeKey={activeInfoTab}
          items={itemInfoCarTabs}
          onChange={(key) => setActiveInfoTab(key)}
        />
      </div>
    </>
  );
};

export default VehicleInformation;
